import { useLiveQuery } from "dexie-react-hooks";
import { Hash, Inbox, Layers, UserRound } from "lucide-react";
import { useState } from "react";
import { colorHex } from "@todoer/shared";
import { CalendarView } from "../components/CalendarView.js";
import { Select } from "../components/overlay.js";
import { Chip, PageHeader } from "../components/ui.js";
import { db, useUser } from "../lib/db.js";
import { sortProjectTree } from "../lib/hooks.js";

export function Calendar() {
  const me = useUser();
  const [projectId, setProjectId] = useState<string | null>(null);
  const [mineOnly, setMineOnly] = useState(false);
  const projects = useLiveQuery(() => db.projects.toArray(), [], []);
  const tasks = useLiveQuery(
    () => db.tasks.filter((t) => !t.completedAt && !!t.due && (!projectId || t.projectId === projectId) && (!mineOnly || !t.assigneeId || t.assigneeId === me?.id)).toArray(),
    [projectId, mineOnly, me?.id], [],
  );
  const options = [
    { value: null as string | null, label: "All projects", icon: Layers },
    ...sortProjectTree(projects.filter((p) => !p.isArchived)).map((p) => ({
      value: p.id as string | null, label: p.isInbox ? "Inbox" : p.name, indent: p.depth,
      icon: p.isInbox ? Inbox : Hash, iconColor: p.isInbox ? "var(--color-info)" : colorHex(p.color),
    })),
  ];
  const toolbar = (
    <div className="flex w-full items-center gap-2 md:w-auto">
      <Chip icon={UserRound} active={mineOnly} aria-pressed={mineOnly} onClick={() => setMineOnly((m) => !m)}>Mine only</Chip>
      <div className="min-w-0 flex-1 md:w-44 md:flex-none">
        <Select label="Project" variant="chip" value={projectId} onChange={setProjectId} options={options} search={options.length > 8} className="w-full" />
      </div>
    </div>
  );
  return (
    <div>
      <PageHeader title="Calendar" />
      <CalendarView tasks={tasks} projects={projects} projectId={projectId} toolbar={toolbar} />
    </div>
  );
}
